export const IMAGE_UPLOAD_INFO_SCREEN_NAME = "ImageUploadInfo"; // when you click on 'Click to add an image'
export const IMAGE_UPLOAD_COMPLETE_SCREEN_NAME = "ImageUploadComplete";
export const PHOTO_MODAL_SCREEN_NAME = "PhotoModal"; // when you click on 'Upload'

export const VIDEO_ROOM_PHOTO_MODAL_FIELD_IDENTIFIER = "medicalInfo";
export const VIDEO_ROOM_PHOTO_MODAL_SCREEN_NAME = "VideoRoomPhotoModal";

export const getScreenNameComparator = name => screen => screen.name === name;
